import PropTypes from 'prop-types';

export default PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]);


//////////////////
// WEBPACK FOOTER
// ../~/react-leaflet/es/propTypes/children.js
// module id = 15
// module chunks = 0